import CourseSectionReportData from './CourseSectionReportData';

export default CourseSectionReportData;
